/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ websiteDisplay: NonNullable<unknown> }} Home_Noncustomer_Btn_PlansInputs */

const en_home_noncustomer_btn_plans = /** @type {(inputs: Home_Noncustomer_Btn_PlansInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore Plans at ${i?.websiteDisplay}`)
};

const fr_home_noncustomer_btn_plans = /** @type {(inputs: Home_Noncustomer_Btn_PlansInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explorer les régimes sur ${i?.websiteDisplay}`)
};

/**
* | output |
* | --- |
* | "Explore Plans at {websiteDisplay}" |
*
* @param {Home_Noncustomer_Btn_PlansInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_noncustomer_btn_plans = /** @type {((inputs: Home_Noncustomer_Btn_PlansInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Noncustomer_Btn_PlansInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_noncustomer_btn_plans(inputs)
	return fr_home_noncustomer_btn_plans(inputs)
});